import React from 'react';
import PropTypes from 'prop-types';
import styles from './IframeForm.css';
import FormSubmissionControls from './FormSubmissionControls.js';

const EMPTY_DATA = {
  title: '',
  subtitle: '',
  content: ''
};

export default class IframeForm extends React.Component {
  constructor(props) {
    super(props);

    this.onCancel =  this.onCancel.bind(this);
    this.onSubmit =  this.onSubmit.bind(this);
    this.onTextInputChange =  this.onTextInputChange.bind(this);

    this.state = Object.assign({
      formValidationText: ''
    }, props.data);
  }

  onTextInputChange(stateKey) {
    return (e) => {
      const text = e.target.value;
      this.setState({[stateKey]: text});
    };
  }

  onCancel() {
    this.setState(EMPTY_DATA);
    this.props.onCancel();
  }

  onSubmit() {
    if(! this.isValid()) {
      return; // early exit
    }

    const newData = Object.assign({
      categories: [
        'custom',
        'iframe'
      ],
      subtype: 'iframe',
      icon: 'IFrame'
    }, this.state);
    this.props.onSubmit(newData);
  }

  isValid() {
    const { title, content } = this.state;
    const validityMessages = [];

    if(title.length === 0) {
      validityMessages.push('Title is required');
    }
    if(content.length === 0) {
      validityMessages.push('URL is required');
    }

    const isValid = validityMessages.length === 0;
    if(! isValid) {
      this.setState({
        formValidationText: validityMessages.join('; ')
      });
    }

    return isValid;
  }

  render() {
    const { isEditing } = this.props;
    const { formValidationText } = this.state;

    const formValidationMessage = (
      <p className={styles.formValidationMessage}>
        {formValidationText}
      </p>
    );

    return (
      <form>
        <p>
          iFrame lets you embed a web page hosted outside the application inside a widget by specifying the URL.
        </p>

        <section>
          <div className={styles.formField}>
            <label className={styles.label}>Title</label>
            <input
              type="text"
              value={this.state.title}
              onChange={this.onTextInputChange('title')}
              className={styles.textInput}
            />
          </div>

          <div className={styles.formField}>
            <label className={styles.label}>Subtitle</label>
            <input
              type="text"
              value={this.state.subtitle}
              placeholder="Optional"
              onChange={this.onTextInputChange('subtitle')}
              className={styles.textInput}
            />
          </div>

          <div className={styles.formField}>
            <label className={styles.label}>URL</label>
            <input
              type="text"
              value={this.state.content}
              placeholder="https://example.com"
              onChange={this.onTextInputChange('content')}
              className={styles.contentInput}
            />
          </div>
        </section>

        {formValidationText.length > 0 ? formValidationMessage: null}

        <FormSubmissionControls
          onCancel={this.onCancel}
          onSubmit={this.onSubmit}
          submitButtonText={isEditing ? 'Save' : undefined}
        />
      </form>
    );
  }
}

IframeForm.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    content: PropTypes.string
  }),
  isEditing: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

IframeForm.defaultProps = {
  data: EMPTY_DATA,
  isEditing: false
};
